var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"600px","min-width":"1200px"},attrs:{"id":"honor"}},[_c('img',{staticStyle:{"border":"0","margin-bottom":"-5px","padding":"0","width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"src":_vm.tempdata.imageUrl,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a4f1e27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/honor.vue
// module id = null
// module chunks = 